/* SIFI BEAUVOIS — Page contact — accordéons FAQ animés (2 niveaux, WAAPI,
   ouverture automatique des questions à l'ouverture d'une catégorie) + reveals des titres. */
  (function () {
    'use strict';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function smoothDetails(item, summary, content, hooks) {
      if (item.dataset.sbFaqAccInit === '1') return;
      item.dataset.sbFaqAccInit = '1';
      hooks = hooks || {};

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      function onFinish(open) {
        item.open = open;
        animation = null;
        isClosing = false;
        isExpanding = false;
        item.style.height = '';
        item.style.overflow = '';
      }

      function shrink() {
        isClosing = true;
        var startHeight = item.offsetHeight + 'px';
        var endHeight = summary.offsetHeight + 'px';
        if (animation) animation.cancel();
        animation = item.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        animation.onfinish = function () { onFinish(false); };
        animation.oncancel = function () { isClosing = false; };
      }

      function expand() {
        isExpanding = true;
        var startHeight = item.offsetHeight + 'px';
        var endHeight = (summary.offsetHeight + content.offsetHeight) + 'px';
        if (animation) animation.cancel();
        animation = item.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        animation.onfinish = function () { onFinish(true); };
        animation.oncancel = function () { isExpanding = false; };
      }

      function open() {
        if (hooks.beforeOpen) hooks.beforeOpen();
        item.style.height = item.offsetHeight + 'px';
        item.open = true;
        window.requestAnimationFrame(expand);
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (reduce) {
          if (!item.open && hooks.beforeOpen) hooks.beforeOpen();
          item.open = !item.open;
          return;
        }
        item.style.overflow = 'hidden';
        if (isClosing || !item.open) open();
        else if (isExpanding || item.open) shrink();
      });
    }

    function initFaqAccordion(root) {
      var scope = root || document;

      // Questions (niveau imbriqué)
      scope.querySelectorAll('.sb-contact-faq-question').forEach(function (q) {
        var summary = q.querySelector(':scope > summary');
        var answer = q.querySelector(':scope > .sb-contact-faq-question__answer');
        if (summary && answer) smoothDetails(q, summary, answer);
      });

      // Catégories (niveau parent) — ouvre toutes ses questions à l'ouverture
      scope.querySelectorAll('.sb-contact-faq-item').forEach(function (item) {
        var summary = item.querySelector(':scope > summary');
        var content = item.querySelector(':scope > .sb-contact-faq-item__content');
        if (!summary || !content) return;

        smoothDetails(item, summary, content, {
          beforeOpen: function () {
            item.querySelectorAll('.sb-contact-faq-question').forEach(function (q) {
              q.style.height = '';
              q.style.overflow = '';
              q.open = true;
            });
          }
        });
      });
    }

    function initTitleReveals(root) {
      var scope = root || document;
      var els = Array.prototype.slice.call(scope.querySelectorAll('.sb-contact-reveal'));
      if (!els.length) return;

      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

      els.forEach(function (el) { observer.observe(el); });
    }

    function initContactPage(root) {
      initFaqAccordion(root);
      initTitleReveals(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initContactPage(document); });
    } else {
      initContactPage(document);
    }
  })();